// extracted by mini-css-extract-plugin
module.exports = {"next":"_319b8ae"};